import { Component } from 'react';
import {Link} from 'react-scroll';


// Assets
import navbarLogo from '../../assets/logo.svg';
import navbarMenu from '../../assets/align-justify.svg';
import cross from '../../assets/x.svg';

export default class Navbar extends Component {

    constructor(props) {

        super(props);

        this.state = {            
            menuButtonStatus: true,
        }
    }

    render() {

        return (
            <div className='Navbar'>
                <div className='Navbar_Logo'>
                    <img src={navbarLogo}/>
                    SHARPERS
                </div>

                <div className='Navbar_Content1'>
                    <div className='Content1'><Link to="Home" smooth={true} duration={1000}>HOME</Link></div>
                    <div className='Content1'><Link to="Service" smooth={true} duration={1000}>SERVICE</Link></div>
                    <div className='Content1'><Link to="Client" smooth={true} duration={1000}>CLIENT</Link></div>
                    <div className='Content1'><Link to="AboutUs" smooth={true} duration={1000}>ABOUT US</Link></div>
                    <div className='Content1'><Link to="ContactUs" smooth={true} duration={1000}>CONTACT US</Link></div>
                </div> 
                
                {this.state.menuButtonStatus ?
                    <div className='Navbar_MenuButton'>
                        <img src={navbarMenu} alt="Navbar_MenuButton" onClick={() => this.setState({menuButtonStatus: !this.state.menuButtonStatus})}/>
                    </div>
                    :
                    <div className='Navbar_Content2'>
                        <img className="Navbar_MenuCloseButton" src={cross} alt="Navbar_CrossButton" onClick={() => this.setState({menuButtonStatus: !this.state.menuButtonStatus})}/>
                        <div className='Content1'><Link to="Home" smooth={true} duration={1000}>HOME</Link></div>
                        <div className='Content1'><Link to="Service" smooth={true} duration={1000}>SERVICE</Link></div>
                        <div className='Content1'><Link to="Client" smooth={true} duration={1000}>CLIENT</Link></div>
                        <div className='Content1'><Link to="AboutUs" smooth={true} duration={1000}>ABOUT US</Link></div>
                        <div className='Content1'><Link to="ContactUs" smooth={true} duration={1000}>CONTACT US</Link></div>
                    </div>
                }
                
            </div>
        );
    }
}